import { action } from 'typesafe-actions';
import {
  BUNDLES_FAILURE,
  BUNDLES_REQUEST,
  BUNDLES_SUCCESS,
  PAYMENT_FAILURE,
  PAYMENT_INTENT_REQUEST,
  PAYMENT_INTENT_SUCCESS,
  PAYMENT_INTENT_FAILURE,
  PREMIUM_PAYMENT_INTENT_REQUEST,
  PREMIUM_PAYMENT_INTENT_SUCCESS,
  PREMIUM_PAYMENT_INTENT_FAILURE,
  PAYMENT_REQUEST,
  PAYMENT_SUCCESS,
  PREMIUM_PAYMENT_SUCCESS,
  STRIPE_FAILURE,
  STRIPE_REQUEST,
  STRIPE_SUCCESS,
  COUPON_PAYMENT_INTENT_REQUEST,
  COUPON_PAYMENT_INTENT_SUCCESS,
  COUPON_PAYMENT_INTENT_FAILURE,
  COUPON_PAYMENT_SUCCESS,
} from '../../constants/payments';

export const bundlesRequestAction = () => action(BUNDLES_REQUEST);
export const bundlesSuccessAction = (data: any) =>
  action(BUNDLES_SUCCESS, data);
export const bundlesFailureAction = (e: any) => action(BUNDLES_FAILURE, e);

export const stripeRequestAction = (o: any) => action(STRIPE_REQUEST, o);
export const stripeSuccessAction = (data: any) => action(STRIPE_SUCCESS, data);
export const stripeFailureAction = (e: any) => action(STRIPE_FAILURE, e);

export const paymentRequestAction = (o: any) => action(PAYMENT_REQUEST, o);
export const paymentSuccessAction = (data: any) =>
  action(PAYMENT_SUCCESS, data);
export const paymentFailureAction = (e: any) => action(PAYMENT_FAILURE, e);

export const paymentIntentRequestAction = (o: any) =>
  action(PAYMENT_INTENT_REQUEST, o);
export const paymentIntentSuccessAction = (data: any) =>
  action(PAYMENT_INTENT_SUCCESS, data);
export const paymentIntentFailureAction = (e: any) =>
  action(PAYMENT_INTENT_FAILURE, e);

export const couponPaymentIntentRequestAction = (o: any) =>
  action(COUPON_PAYMENT_INTENT_REQUEST, o);
export const couponPaymentIntentSuccessAction = (data: any) =>
  action(COUPON_PAYMENT_INTENT_SUCCESS, data);
export const couponPaymentIntentFailureAction = (e: any) =>
  action(COUPON_PAYMENT_INTENT_FAILURE, e);
export const couponPaymentSuccessAction = (data: any) =>
  action(COUPON_PAYMENT_SUCCESS, data);

export const premiumPaymentIntentRequestAction = (o: any) =>
  action(PREMIUM_PAYMENT_INTENT_REQUEST, o);
export const premiumPaymentIntentSuccessAction = (data: any) =>
  action(PREMIUM_PAYMENT_INTENT_SUCCESS, data);
export const premiumPaymentIntentFailureAction = (e: any) =>
  action(PREMIUM_PAYMENT_INTENT_FAILURE, e);
export const premiumPaymentSuccessAction = (data: any) =>
  action(PREMIUM_PAYMENT_SUCCESS, data);

export const paymentActions = {
  paymentRequestAction,
  paymentSuccessAction,
  paymentFailureAction,
  stripeRequestAction,
  stripeSuccessAction,
  stripeFailureAction,
  bundlesRequestAction,
  bundlesSuccessAction,
  bundlesFailureAction,
  paymentIntentRequestAction,
  paymentIntentSuccessAction,
  paymentIntentFailureAction,
  couponPaymentIntentRequestAction,
  couponPaymentIntentSuccessAction,
  couponPaymentIntentFailureAction,
  couponPaymentSuccessAction,
  premiumPaymentIntentRequestAction,
  premiumPaymentIntentSuccessAction,
  premiumPaymentIntentFailureAction,
  premiumPaymentSuccessAction,
};
